<template>
<div class="chapter">
<div class="inner_page">
<div class="galley-rw">
<section class="frontmatter-rw Dedication-rw exclude-auto-rw page-open-right-rw" epub:type="frontmatter dedication" id="Dedication1">
<div class="block-rw dedication-rw" id="dedication1">
<p class="ded-rw" id="p16" style="text-align: center;"><span><span>For the Chief, as always, with love and such.</span></span></p>
</div>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// s003-Dedication-01.vue?480cd068